interface ShellPrerequisiteLoaders<TBilling> {
  /** Loads ListOrganizationUsers: the effective permission set the sidebar gates on. */
  permissions: () => Promise<unknown>
  /** Loads GetOrganizationBillingState, or null when the billing gate is skipped (demo mode). */
  billing: (() => Promise<TBilling>) | null
}

/**
 * Resolves what the authenticated shell needs before its first paint: the
 * selected organization's permission set and its billing access state.
 *
 * The two requests are independent (both only need the organization id), so
 * they start together instead of the billing lookup waiting a full round trip
 * behind the permission lookup on every cold load. Failures are swallowed:
 * the sidebar degrades to its ungated items, and a billing lookup error fails
 * open (resolves to null) to match the server interceptor.
 */
export async function loadShellPrerequisites<TBilling>(
  loaders: ShellPrerequisiteLoaders<TBilling>,
): Promise<TBilling | null> {
  const [, billing] = await Promise.all([
    loaders.permissions().catch(() => undefined),
    loaders.billing ? loaders.billing().catch(() => null) : null,
  ])
  return billing ?? null
}
